export default __webpack_public_path__ + "static/media/2.fff18059.jpg";